const content: { [key: string]: any } = {
  annual: {
    personal: "Annual PPV",
    group: "Annual GPV",
    ruby: "Annual Ruby PV",
    annualGpv: "Annual GPV",
  },
  monthly: {
    personal: "PPV",
    group: "GPV",
    ruby: "Ruby PV",
    annualGpv: "GPV",
  },
  status: {
    achieved: "Congrats, you’ve achieved your {volumeType} requirement!",
    tracking: "You’re on track to meet the {volumeType} requirement.",
    notTracking: "You’re not tracking to meet the {volumeType} requirement.",
    exempt: "You’re exempt from this requirement.",
  },
  trackerTitle: "<1>{currentVolume}</1>/{targetVolume} Monthly {volumeType} Tracker (Through {month})",
  description: "Use the dial to see how you're tracking for the performance year.",
  volumeYtd: "{volumeType} YTD",
  neededForOnTrack: "Total {volumeType} YTD needed to be on track by end of {currentMonth}",
  pyChartTitle: "PY{perfYear}",
  requirements: {
    exempt: {
      tooltip: "You are currently exempt from having to meet this requirement.",
    },
  },
  accessibility: {
    exempt: "Exempt: {volumeType}. You are currently exempt from having to meet this requirement.",
    status: "{volumeType} requirement: {current} of {target}. Status: {status}.",
    statusValues: {
      achieved: "achieved",
      onTrack: "on track",
      belowTarget: "below target",
    },
    icon: "Requirement achieved",
    exemptPrefix: "Exempt: ",
    exemptInfo: "Information about exemption",
    exemptAnnouncement: "Exempt: {volumeType}. You are currently exempt from having to meet this requirement.",
    chartExempt: "Progress chart for {volumeType} requirement. You are exempt from this requirement.",
    chartProgress:
      "Progress chart for {volumeType} requirement over 12 months. {achieved} months achieved target, {below} months below target, {future} future months remaining.",
  },
} as const;

export default content;
